import { render, staticRenderFns } from "./WikiEdit.vue?vue&type=template&id=67c8831c&scoped=true"
import script from "./WikiEdit.vue?vue&type=script&lang=js"
export * from "./WikiEdit.vue?vue&type=script&lang=js"
import style0 from "./WikiEdit.vue?vue&type=style&index=0&id=67c8831c&prod&lang=scss"
import style1 from "./WikiEdit.vue?vue&type=style&index=1&id=67c8831c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8831c",
  null
  
)

export default component.exports